import React from 'react';
import { X, Check } from 'lucide-react';
export function UpsellSection() {
  const withoutUpsell = ['Solo sabes hacer cableados básicos', 'Pierdes trabajos industriales bien pagados', 'Te regatean el precio constantemente', 'No sabes diagnosticar fallas complejas', 'Dependes de "probar a ver qué pasa"'];
  const withUpsell = ['Dominas PLC y Comandos Industriales', 'Accedes a mantenimiento de fábricas y edificios', 'Cobras como un verdadero especialista', 'Interpretas planos y diagramas con seguridad', 'Armas tableros profesionales y estéticos'];
  return <section className="py-8 md:py-14 px-4 bg-brand-section border-t-2 border-gray-200" data-id="element-285">
      <div className="max-w-4xl mx-auto" data-id="element-286">
        <div className="text-center mb-8" data-id="element-287">
          <h2 className="text-xl md:text-3xl font-black text-brand-text mb-2 uppercase leading-tight" data-id="element-288">
            LA DIFERENCIA ENTRE UN{' '}
            <span className="text-brand-danger" data-id="element-289">AYUDANTE</span> Y UN{' '}
            <span className="text-brand-primary" data-id="element-290">ESPECIALISTA</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6" data-id="element-291">
          {/* Sin Upsell */}
          <div className="bg-white rounded-2xl border-t-8 border-brand-danger p-5 md:p-6 shadow-lg" data-id="element-292">
            <h3 className="text-base md:text-lg font-black text-brand-text mb-5 flex items-center justify-center uppercase" data-id="element-293">
              <X className="w-5 h-5 md:w-6 md:h-6 mr-1.5 text-brand-danger" data-id="element-294" />{' '}
              ELECTRICISTA COMÚN
            </h3>
            <ul className="space-y-3" data-id="element-295">
              {withoutUpsell.map((item, i) => <li key={i} className="flex items-start" data-id="element-296">
                  <X className="w-4 h-4 md:w-5 md:h-5 text-brand-danger mr-2 shrink-0 mt-0.5" data-id="element-297" />
                  <span className="text-brand-steel font-bold text-xs md:text-sm" data-id="element-298">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Con Upsell */}
          <div className="bg-white rounded-2xl border-t-8 border-brand-primary p-5 md:p-6 shadow-xl transform md:-translate-y-2" data-id="element-299">
            <h3 className="text-base md:text-lg font-black text-brand-primary mb-5 flex items-center justify-center uppercase" data-id="element-300">
              <Check className="w-5 h-5 md:w-6 md:h-6 mr-1.5" data-id="element-301" /> MASTER
              ELECTROTÉCNICO
            </h3>
            <ul className="space-y-3" data-id="element-302">
              {withUpsell.map((item, i) => <li key={i} className="flex items-start" data-id="element-303">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-primary mr-2 shrink-0 mt-0.5" data-id="element-304" />
                  <span className="text-brand-text font-black text-xs md:text-sm" data-id="element-305">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}